module.exports = __webpack_public_path__ + "static/media/bubble-pop.94cecb17.ogg";